import { SWITCH_LANGUAGE, SWITCH_TIME_ZONE } from 'constants/ActionTypes';
import { storage } from 'packages/utils';

import {
  LAYOUT_TYPE,
  LAYOUT_TYPE_FULL,
  NAV_STYLE,
  NAV_STYLE_FIXED,
  THEME_COLOR,
  THEME_TYPE,
  THEME_TYPE_SEMI_DARK,
} from 'constants/ThemeSetting';
import languageData from 'containers/Topbar/languageData';
import { DateUtil } from '@src/packages/utils/dates';

const getDefaultLanguage = () => {
  const language = languageData.find(l => l.locale === 'es');
  return language;
};

const initialSettings = {
  navStyle: NAV_STYLE_FIXED,
  layoutType: LAYOUT_TYPE_FULL,
  themeType: THEME_TYPE_SEMI_DARK,
  themeColor: null,

  isDirectionRTL: false,
  locale: storage.get('locale', getDefaultLanguage()),
  timeZone: storage.get('timeZone', DateUtil.getDefaultTimeZone()),
};

const settings = (state = initialSettings, action) => {
  switch (action.type) {
    case THEME_TYPE:
      return {
        ...state,
        themeType: action.themeType,
      };
    case THEME_COLOR:
      return {
        ...state,
        themeColor: action.themeColor,
      };

    case NAV_STYLE:
      return {
        ...state,
        navStyle: action.navStyle,
      };
    case LAYOUT_TYPE:
      return {
        ...state,
        layoutType: action.layoutType,
      };

    // Both cases bail out when the value is unchanged: `containers/App` selects the whole
    // settings slice, so a new object identity alone re-renders the entire app shell.
    case SWITCH_LANGUAGE:
      if (state.locale?.locale === action.payload?.locale) {
        return state;
      }
      return {
        ...state,
        locale: action.payload,
      };

    case SWITCH_TIME_ZONE:
      if (state.timeZone === action.payload) {
        return state;
      }
      return {
        ...state,
        timeZone: action.payload,
      };
    default:
      return state;
  }
};

export default settings;
